export default {
  HUD: 'hud',
  POP_UP_WINDOW: 'popupwindow',
  BATTLE: 'battle',
};
